import { render, staticRenderFns } from "./PartnerCalculationsSettlement.vue?vue&type=template&id=4695a630&scoped=true"
import script from "./PartnerCalculationsSettlement.vue?vue&type=script&lang=js"
export * from "./PartnerCalculationsSettlement.vue?vue&type=script&lang=js"
import style0 from "./PartnerCalculationsSettlement.vue?vue&type=style&index=0&id=4695a630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4695a630",
  null
  
)

export default component.exports